import { guardNumber } from "@msuite/utils/numbers";
import type { Nullable } from "@msuite/utils/types";
import { AnimatedNumber } from "./animated-number";

/** Props Interface */
export interface AnimatedTimeProps {
	hours: Nullable<number>;
	minutes: Nullable<number>;
	seconds: Nullable<number>;
}

export function AnimatedTime({ hours, minutes, seconds }: AnimatedTimeProps) {
	/** Render */
	return (
		<div className="h-stack gap-0.5">
			<AnimatedNumber
				value={guardNumber(hours)}
				className="tabular-nums"
				format={{
					minimumIntegerDigits: 2,
				}}
			/>
			<p>:</p>
			<AnimatedNumber
				value={guardNumber(minutes)}
				className="tabular-nums"
				format={{
					minimumIntegerDigits: 2,
				}}
			/>
			<p>:</p>
			<AnimatedNumber
				value={guardNumber(seconds)}
				className="tabular-nums"
				format={{
					minimumIntegerDigits: 2,
				}}
			/>
			<p>h</p>
		</div>
	);
}
